import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { globalStyles as styles } from './style/gstheme';

class ListDisplay extends Component {

  render() {

    const {classes, results, lang, title, handleClickAway, labelDisplay} = this.props;
    const marginTop = this.props.margin === "dense" ? -4 : -8;

    return (
      <ClickAwayListener onClickAway={handleClickAway}>
          <List data-test="list-display" dense className={classes.existingResults} subheader={<ListSubheader>{title}</ListSubheader>} style={{marginTop: marginTop}}>
              {results && results.map((result, i) => 
                <ListItem key={"result-" + i} className={classes.existingResult}>
                    <ListItemText primary={labelDisplay(result, lang)} />
                </ListItem>
              )}                    
          </List>
      </ClickAwayListener>
    );
  }
}

ListDisplay.propTypes = {
  handleClickAway: PropTypes.func.isRequired,
  results: PropTypes.array.isRequired,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
  labelDisplay: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(ListDisplay);